<script setup lang="ts">
import type {
    HeroComponentModel,
    InterventionGetPriceRequestModel,
    InterventionOverviewComponentModel,
    InterventionOverviewContentItem,
} from '@su4r-frontend/api';

const props = defineProps<{ data: InterventionOverviewContentItem }>();

const { status } = useAuth();
const { locale } = useI18n();

// Adds cookie to request for server server side rendering
const headers = useRequestHeaders(['cookie']);

const interventionData = props.data.components.find(
    (comp): comp is InterventionOverviewComponentModel => comp.alias === 'interventionOverview'
);

const heroData = props.data.components?.find(
    (comp): comp is HeroComponentModel => comp.alias === 'heroComponent'
);

const interventionComponents = computed(() => {
    return interventionData?.interventions ?? null;
});

const { data: pricesData } = await useAsyncData(`prices`, async () => {
    return $fetch('/api/interventions/prices', {
        method: 'POST',
        headers,
        body: {
            interventionIds:
                interventionComponents.value?.map(
                    (intervention) => intervention.productReference
                ) ?? [],
            culture: locale.value,
        } as InterventionGetPriceRequestModel,
    });
});
</script>

<template>
    <div class="container grid">
        <PageHero v-bind="heroData" />
        <div class="grid grid-cols-12">
            <div class="col-span-12 grid lg:col-span-8">
                <ProductCard
                    v-for="intervention in interventionComponents"
                    :key="intervention.productReference"
                    :price-data="pricesData?.prices?.[intervention.id]"
                    :data="intervention" />
            </div>
            <div
                v-if="data.aside && status === 'unauthenticated'"
                class="col-span-12 flex flex-col gap-4 lg:col-span-4 lg:row-span-2 lg:gap-6">
                <ProductOverviewCart :data="data.aside" />
            </div>
        </div>
    </div>
</template>
